import React from "react";
import "./middleware/Interceptor";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import store from "./redux/store/Store";
import App from "./App";
import "simplebar/dist/simplebar.min.css";
import "swiper/css/bundle";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./App.scss";
import "./i18nextConf";

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = createTheme({
  palette: {
    color: {
      magentaDark1: "#444561",
      magentaDark2: "#262B3E",
      magentaDark3: "#917D9E",
      magentaMid1: "#6b607e",
      magentaMid2: "#957ba0",
      $magentaMid3: "#917d9e",
      magentaLight1: "#c298bb",
      magentaLight2: "#dfc8db",
      brown: "#444561",
      dimGrey: "#707070",
      dimGrey2: "#cccccc",
      lightGrey: "#DEDEDE",
      darkGrey: "#a5a5a5",
      black: "#000",
      white: "#fff",
      smokeWhite: "#ededed",
      transparent: "transparent",
      dark1: "#444660",
    },
  },
  typography: {
    allVariants: {
      color: "#444561",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          fontSize: "bold",
        },
      },
    },
  },
});

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
